import { render, staticRenderFns } from "./RegulatingTank.vue?vue&type=template&id=20be8872&scoped=true"
import script from "./RegulatingTank.vue?vue&type=script&lang=js"
export * from "./RegulatingTank.vue?vue&type=script&lang=js"
import style0 from "./RegulatingTank.vue?vue&type=style&index=0&id=20be8872&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20be8872",
  null
  
)

export default component.exports